import { TextureSource } from "../types";

import * as twgl from "twgl.js";

/**
 * Create and fill a webgl texture
 * If source is a texture, it will just be returned without creating a new texture
 * @param context Webgl context to create the texture on
 * @param source Source used to fill the texture
 * @returns Created texture, or source if it's a WebGLTexture
 */
export function texture(
    context: WebGLRenderingContext,
    source?: TextureSource | WebGLTexture
): () => WebGLTexture {
    return () =>
        source instanceof WebGLTexture
            ? source
            : twgl.createTexture(context, {
                  src: source,
                  wrap: context.CLAMP_TO_EDGE,
              });
}

/**
 * Minimum size for a webgl texture
 */
export const WEBGL_MINIMUM_TEXTURE_SIZE: number = 2;
